import type { SelectValue } from '@/layer/ui/models/forms/Select.model'
import type { DatepickerModelValue } from '@/layer/ui/models/forms/Datepicker.model'
import type { AdhocSessionRequest } from '@/models/AdhocSession.model'

export interface ReceiptState {
  loading: boolean
  error: string | null
  isAvailable: boolean
  downloadUrl: string | null
}

export interface ReceiptErrorResponse {
  success: false
  errorCode: string
  error: string
}

export interface ReceiptSuccessResponse {
  success: true
}

export type ReceiptApiResponse = ReceiptSuccessResponse | ReceiptErrorResponse

export interface ReceiptSearchFormData {
  country: SelectValue
  date: DatepickerModelValue
  price: string
  creditCard: string
}

export const mapFormDataToAdhocSessionRequest = (clientUuid: string, data: ReceiptSearchFormData): AdhocSessionRequest => {
  return {
    clientUuid: clientUuid,
    country: data.country as string,
    date: data.date.toString(),
    price: data.price.replace(',', '.'),
    lastDigits: data.creditCard,
  }
}
